import React, { useContext, useEffect, useState } from 'react'
import { IndentedOption, SubOptionsRow } from './utils'
import { InputNumber } from 'antd'
import { CourseContext } from '../../../Course/CourseContext'
import { Course } from '../../../Course/types'

const DEFAULT_VALIDITY = 6

type CertificateValidityOptionProps = {
  course: Course
  examValidityMonths: number
}

const CertificateValidityOption = ({ course, examValidityMonths }: CertificateValidityOptionProps)  => {
  const { updateCourse } = useContext(CourseContext)
  const [ validity, setValidity ] = useState(examValidityMonths || DEFAULT_VALIDITY)

  useEffect(() => {
    if (validity) {
      updateCourse({
        ...course,
        examValidityMonths: validity,
      })
    }
  }, [ validity ])

  return (
    <IndentedOption>
      <SubOptionsRow>
        Gültigkeit in Monaten {/* TODO: i18n */}
      </SubOptionsRow>
      <SubOptionsRow>
        <InputNumber
          defaultValue={validity}
          onChange={(value: number | null) => setValidity(value || 0)}
        />
      </SubOptionsRow>
    </IndentedOption>
  )
}

export default CertificateValidityOption